import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import SvgIcon from '../common/SvgIcon';

class Panel extends React.Component {
  constructor(props) {
    super(props);
    this.loadList = this.loadList.bind(this);
    this.linkClicked = this.linkClicked.bind(this);
    this.state = {};
  }

  linkClicked(e) {
    this.props.linkClicked(e);
  }

  loadList(data) {
    const list = [];
    _.map(data, (li, index) => {
      list.push(
        <li className="c-panel__item" key={index}>
          <a
            id={li.id}
            className="c-panel__sblink"
            name={li}
            href="#"
            onClick={this.linkClicked}
          >
            {' '}
            {li.name}
          </a>
        </li>
      );
    });
    return list;
  }

  render() {
    return (
      <aside id="site-sidebar" tabIndex="-1">
        <div className="c-panel">
          <div className="c-panel-info">
            <h3 className="c-panel__heading">
              <span className={'c-panel__icons'}>
                <SvgIcon id={this.props.iconClass} width="16px" height="16px" />
              </span>
              Quick Links
            </h3>
            <div className="c-panel__body">
              <ul className="c-panel__list">
                {this.loadList(this.props.SideBarlist)}
              </ul>
            </div>
          </div>
        </div>
      </aside>
    );
  }
}

Panel.propTypes = {
  accountType: PropTypes.string,
  className: PropTypes.string,
  SideBarlist: PropTypes.array,
  showSideBarMobile: PropTypes.func,
  linkClicked: PropTypes.func,
  sideBarButtons: PropTypes.object,
};
Panel.defaultProps = {
  accountType: 'current',
  SideBarlist: [],
  className: '',
  sideBarButtons: '',
};
export default Panel;
